import { AnimatePresence, motion } from "framer-motion";
import { CheckCircle, AlertCircle } from "lucide-react";
import { useQuotation } from "../context/QuotationContext";

const QuotationToast = () => {
  const { toast } = useQuotation();
  const isDuplicate = toast?.includes("ya está");

  return (
    <AnimatePresence>
      {toast && (
        <motion.div
          initial={{ opacity: 0, y: 50, scale: 0.95 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 20, scale: 0.95 }}
          className="fixed z-[1200] left-1/2 -translate-x-1/2 bottom-[calc(var(--bottom-nav-h)+env(safe-area-inset-bottom,0px)+20px)] md:bottom-8 px-5 py-3 rounded-2xl bg-brand-dark text-white shadow-2xl flex items-center gap-3 max-w-[90vw]"
          role="status"
          aria-live="polite"
        >
          {isDuplicate ? (
            <AlertCircle className="text-brand-accent shrink-0" size={18} />
          ) : (
            <CheckCircle className="text-brand-accent shrink-0" size={18} />
          )}
          <span className="text-sm font-medium">{toast}</span>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default QuotationToast;
